import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LineText } from 'Components/Texts';
import { LinkSubmitButton } from 'Components/Fields/Buttons';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { getPlans, selectPlan } from 'State/Plans/PlansActions';
import { SectionTitle } from 'Components/Titles';
import { Loader } from 'Components/Loader';
import { PlanList } from 'Features/Plans/PlanList';
import { isDefaultPlanFlow } from 'Utils/Analytics/Amplitude';
import './Packages.css';

const routes = GLOBAL_ROUTES;

const Packages = ({ source = {} }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { profileId } = useSelector((s) => s.user);
  const plans = useSelector((s) => s.plans);
  const { allPlans, freePromo, getPlansSuccess, selectedPlanPrice } = plans;

  useEffect(() => {
    if (!getPlansSuccess) {
      dispatch(getPlans());
    }
  }, [dispatch, getPlansSuccess]);

  const handleSelectPackage = (planId) => {
    dispatch(selectPlan(planId));
    trackEvent(
      TRACKING_ENUMS.EVENT_PLAN_SELECT_COMPLETE,
      { page_plan_price: selectedPlanPrice },
      { dcg_profile_id: profileId }
    );
    const route = isDefaultPlanFlow() ? routes.signupCreateAccount : routes.signupPlans;
    navigate(route);
  };

  const { description = '', subDescription = '', headline = '', subHeadline = '', ctaText = '' } = source;
  const plansLoaded = allPlans.length > 0;

  const route = isDefaultPlanFlow() ? routes.signupCreateAccount : routes.signupPlans;

  if (!plansLoaded) {
    return <Loader />;
  }

  return (
    <div>
      <div className="packageSection">
        {subHeadline && <LineText text={subHeadline} overTextLine />}
        <SectionTitle className="packageList" text={headline} align="center" />
        {description && <p className="packageSubHeadline">{description}</p>}
        <PlanList isDisplayOnly onSelectPlan={handleSelectPackage} plans={allPlans} planPromos={freePromo} />
        {subDescription && <p className="packageSubDesc">{subDescription}</p>}
        {ctaText && <LinkSubmitButton path={route} text={ctaText} />}
      </div>
    </div>
  );
};

export { Packages };
